import "../../src/assets/styles/Header.css";
import img_logo from "../imgs/logo.png";
import iconBack from "../icons/icon-back.png";
import imgTitleSupCskh from "../imgs/title-sup-cskh.png";
import imgTitleFullName from "../imgs/title-full-name.png";
import imgTitlePhone from "../imgs/title-phone.png";
import imgTitleEmail from "../imgs/title-email.png";
import imgTitleBank from "../imgs/title-bank.png";
import { useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";

function Header({ isPageSearch, pageToAcction, data, currentPage, isPageChangeInfo }) {
  const navigate = useNavigate();
  const backToSearch = () => {
    if (pageToAcction) navigate(pageToAcction, { state: data });
    else navigate("/");
  };
  const linkHome = data?.webSetting?.link_home || "#"

  return (
    <div>
      <div className="status-bar"></div>
      <div className="header">
        <div className="header-logo">
          {!isPageSearch && (
            <img
              className="img-icon-back"
              style={{ cursor: "pointer" }}
              src={iconBack}
              alt="icon-back"
              id="btn-back"
              onClick={backToSearch}
            />
          )}
          {!isPageChangeInfo && 
            <div className="main-logo">
              <img src={img_logo} alt="logo"></img>
              <HomeIcon
                sx={{
                  position: "absolute",
                  backgroundColor: "white",
                  borderRadius: "50%",
                  padding: 1,
                  top: 5,
                  left: 15,
                  fontSize: 30,
                  fill: "#34a749",
                  cursor: "pointer",
                }}
                onClick={() => (window.location.href = linkHome)}
              />
            </div>
          }
        </div>
        
        {!isPageChangeInfo && 
          <p>HỖ TRỢ KHÁCH HÀNG</p>
        }
      </div>
    </div>
  );
}

export default Header;
